export const LICENSE_TYPE_OPTIONS = ["FVOD", "SVOD", "SVOD+FVOD"] as const;

export const FORMAT_PROFILE_OPTIONS = ["SD", "HD", "UHD"] as const;

/** Stored/API value when Branding Rights checkbox is checked. */
export const BRANDING_RIGHTS_CHECKED_VALUE = "True";

/** Stored/API value when HDR10 checkbox is checked. */
export const HDR_CHECKED_VALUE = "HDR10";

export const LICENSE_WINDOW_RANGE_TOOLTIP =
    "Filters titles whose playback start falls on or within the selected date(s).";

export function isBrandingRightsChecked(value: string | null | undefined): boolean {
    const text = String(value ?? "").trim().toLowerCase();
    return text === "true" || text === "yes";
}

export function isHdrChecked(value: string | null | undefined): boolean {
    const text = String(value ?? "").trim().toUpperCase();
    return text === "HDR10" || text === "TRUE" || text === "YES";
}